import React, {Component} from 'react';
import {Button} from 'antd';

import GroupModalForm from './GroupModalForm'

class GroupRootButtonCreate extends Component {
  state = {
    visible: false
  };
  showModal = () => {
    this.setState({visible: true});
  };
  handleCancel = () => {
    this.setState({visible: false});
  };
  handleCreate = () => {
    const form = this.form;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const {ID, ParentID, Name, MoreInfo} = values
      const desc = MoreInfo.desc
        ? MoreInfo.desc
        : ""
      const jsonString = JSON.stringify({desc: desc})
      const info = btoa(unescape(encodeURIComponent(jsonString)))
      const group = {
        ID: ID,
        ParentID: ParentID,
        Name: Name,
        MoreInfo: info
      }
      this.props.onCreate(group)
      form.resetFields();
      this.setState({visible: false});
    });
  };
  saveFormRef = (form) => {
    this.form = form;
  };
  render() {
    const {
      group,
      groups,
      type,
      style,
      text,
      ghost
    } = this.props
    return (<span>
      <Button type={type} style={style} icon="plus" ghost={ghost} onClick={this.showModal}>{text}</Button>
      <GroupModalForm groups={groups} title="Thêm mới địa bàn" group={group} ref={this.saveFormRef} visible={this.state.visible} onCancel={this.handleCancel} onSubmit={this.handleCreate}/>
    </span>);
  }
}

export default GroupRootButtonCreate;



// WEBPACK FOOTER //
// ./src/components/GroupRootButtonCreate.js